import { useOutletContext } from "react-router-dom";
import PageLoader from "components/page-components/PageLoader";
import MainContentLeft from "components/main-components/MainContentLeft";
import Loader from "components/Loader";
import CommonItems from "components/common-item/CommonItems";
import Pagination from "components/Pagination";
import EmptyBlockInventoryCraft from "components/placeholder-blocks/EmptyBlockInventoryCraft";
import emptyImg from "assets/img/icons/empty-identities.svg";
import emptyIcon from "assets/img/icons/craft-identity.svg";

const Identities = () => {
  const {
    items,
    filters,
    isFiltersLoading,
    isItemsLoading,
    offsetCount,
    setOffsetCount,
    paginationData,
    getOpenedClass,
  } = useOutletContext();

  if (!items.length && isFiltersLoading === true) {
    return <PageLoader />;
  }

  return (
    <main className="main-content">
      <MainContentLeft
        getOpenedClass={getOpenedClass}
        filters={filters}
        setOffsetCount={setOffsetCount}
      />
      <div className="main-content__right">
        {isItemsLoading && !items.length ? (
          <Loader />
        ) : items.length ? (
          <>
            <CommonItems items={items} />
            <Pagination
              offsetCount={offsetCount}
              setOffsetCount={setOffsetCount}
              paginationData={paginationData}
            />
          </>
        ) : (
          <EmptyBlockInventoryCraft
            img={emptyImg}
            icon={emptyIcon}
            path="/crafting/identity"
            text="No Identity Cards"
          />
        )}
      </div>
    </main>
  );
};

export default Identities;
